import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { gapi, errMsg } from "../api";
import { useGAuth } from "../GAuth";
import { AuthShell, Field, Submit, Notice } from "../components/AuthShell";

export default function Accesso() {
  const { user, refresh } = useGAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [challenge, setChallenge] = useState(null);
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [info, setInfo] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/gestionale" replace />;

  const run = async (fn) => {
    setError(""); setInfo(""); setLoading(true);
    try { await fn(); } catch (e) { setError(errMsg(e, "Accesso non riuscito")); } finally { setLoading(false); }
  };

  const done = async () => { await refresh(); navigate("/gestionale"); };

  const submitLogin = (e) => { e.preventDefault(); run(async () => {
    const { data } = await gapi.post("/auth/login", { email, password });
    if (data.mfaRequired) setChallenge(data); else await done();
  }); };

  const submitCode = (e) => { e.preventDefault(); run(async () => {
    await gapi.post("/auth/login/verify", { challengeId: challenge.challengeId, code });
    await done();
  }); };

  const resend = () => run(async () => {
    const { data } = await gapi.post("/auth/login/resend", { challengeId: challenge.challengeId });
    setChallenge(data); setInfo("Nuovo codice inviato.");
  });

  if (challenge) {
    return (
      <AuthShell title="Verifica in due passaggi" subtitle={`Abbiamo inviato un codice a 6 cifre a ${challenge.email}.`} testid="g-otp-form">
        {error && <Notice testid="g-otp-error">{error}</Notice>}
        {info && <Notice kind="ok">{info}</Notice>}
        {!challenge.emailInviata && <Notice>Invio email non riuscito. Riprova o usa un codice di recupero.</Notice>}
        <form onSubmit={submitCode}>
          <Field label="Codice di verifica o codice di recupero" value={code} onChange={(e) => setCode(e.target.value)} autoFocus inputMode="text" autoComplete="one-time-code" data-testid="g-otp-code" />
          <Submit loading={loading} data-testid="g-otp-submit">Verifica e accedi</Submit>
        </form>
        <div className="mt-5 flex justify-between text-sm">
          <button onClick={resend} className="text-brand font-medium hover:underline" data-testid="g-otp-resend">Invia un nuovo codice</button>
          <button onClick={() => { setChallenge(null); setCode(""); }} className="text-anthracite/50 hover:underline">Indietro</button>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Accedi al gestionale" subtitle="Area riservata al titolare e ai collaboratori autorizzati." testid="g-login-form">
      {error && <Notice testid="g-login-error">{error}</Notice>}
      <form onSubmit={submitLogin}>
        <Field label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" required data-testid="g-login-email" />
        <Field label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required data-testid="g-login-password" />
        <Submit loading={loading} data-testid="g-login-submit">Accedi</Submit>
      </form>
      <div className="mt-6 flex flex-col gap-2 text-sm">
        <Link to="/gestionale/recupero-password" className="text-brand font-medium hover:underline" data-testid="g-forgot-link">Hai dimenticato la password?</Link>
        <Link to="/gestionale/attivazione" className="text-anthracite/50 hover:underline" data-testid="g-setup-link">Prima attivazione del titolare</Link>
      </div>
      <p className="mt-10 text-xs text-anthracite/40">Non esiste una registrazione pubblica: l'accesso è possibile solo su invito del titolare.</p>
    </AuthShell>
  );
}
